export const CLASS_COLORS = {
  Warrior: "#C79C6E",
  Paladin: "#F58CBA",
  Hunter: "#ABD473",
  Rogue: "#FFF569",
  Priest: "#FFFFFF",
  Shaman: "#0070DE",
  Mage: "#69CCF0",
  Warlock: "#9482C9",
  Druid: "#FF7D0A",
  Unknown: "#64748b",
};

export const GEAR_SLOTS = [
  "Head", "Neck", "Shoulders", "Back", "Chest", "Wrists", "Hands",
  "Waist", "Legs", "Feet", "Ring 1", "Ring 2", "Trinket 1", "Trinket 2",
  "Main Hand", "Off Hand", "Ranged/Relic"
];

export const ENCHANTABLE_SLOTS = [
  "Head", "Shoulders", "Back", "Chest", "Wrists", "Hands", "Legs", "Feet", "Main Hand"
];

export const WOW_CLASSES = [
  "Warrior", "Paladin", "Hunter", "Rogue", "Priest", "Shaman", "Mage", "Warlock", "Druid"
];

export const TEAMS = ["Monday", "Thursday"]; // legacy fallback when no guild loaded

export const CLASS_ROLES = {
  Warrior: "DPS",
  Paladin: "Healer",
  Hunter: "DPS",
  Rogue: "DPS",
  Priest: "Healer",
  Shaman: "DPS",
  Mage: "DPS",
  Warlock: "DPS",
  Druid: "DPS",
  Unknown: "Unknown",
};

export const ROLE_ORDER = ["Tank", "Healer", "DPS", "Unknown"];

export function getPlayerRole(wowClass) {
  return CLASS_ROLES[wowClass] || "Unknown";
}

export const CLASS_ICONS = {
  Warrior: "Shield",
  Paladin: "Cross",
  Hunter: "Target",
  Rogue: "Sword",
  Priest: "Heart",
  Shaman: "Zap",
  Mage: "Sparkles",
  Warlock: "Flame",
  Druid: "Leaf",
  Unknown: "HelpCircle",
};
